export function isFunction(obj: any) {
  return typeof obj == "function";
}

export function isObject(obj: any) {
  var type = typeof obj;
  return type === "function" || (type === "object" && !!obj);
}

export function hasWindowObject() {
  return typeof window !== "undefined" && window.document;
}

export function disableReactDevTools() {
  if (hasWindowObject()) {
    // @ts-ignore
    if (!isObject(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      return;
    }

    // @ts-ignore
    for (const prop in window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
      if (prop === "renderers") {
        // @ts-ignore
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = new Map();
        continue;
      }
      // @ts-ignore
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop] = isFunction(
        // @ts-ignore
        window.__REACT_DEVTOOLS_GLOBAL_HOOK__[prop],
      )
        ? Function.prototype
        : null;
    }
  }
}
